<template>
  <div class="input-wrapper">
    <input
      v-model="value"
      class="filter-input"
      :placeholder="'Search' | i18n"
      @input="searchChange"
    >
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    searchChange: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      value: ''
    };
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
}
.filter-input {
  background: url('../../../../assets/icons/search.png') no-repeat scroll;
  background-position: right 8px center;
  background-size: 14px;
  border: 1px solid #C5D0DE;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 30px 6px 12px;
}
</style>
